import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { terminalRequestsApi } from '@/api/services/terminalRequests';
import type {
  TerminalRequestRefInput,
  UpdateTerminalRequestStatusInput,
} from '@/api/types/terminalRequests';

export const terminalRequestKeys = {
  all: ['terminalRequests'] as const,
  list: ['terminalRequests', 'list'] as const,
  details: (ref: TerminalRequestRefInput) =>
    ['terminalRequests', 'details', ref.tenantId, ref.requestId] as const,
};

export function useTerminalRequestDetails(ref: TerminalRequestRefInput | null) {
  return useQuery({
    queryKey: ref ? terminalRequestKeys.details(ref) : ['terminalRequests', 'details', 'none'],
    queryFn: () => terminalRequestsApi.getDetails(ref as TerminalRequestRefInput),
    enabled: ref !== null,
  });
}

export function useUpdateTerminalRequestStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateTerminalRequestStatusInput) =>
      terminalRequestsApi.updateStatus(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: terminalRequestKeys.list }),
  });
}
